import { render, staticRenderFns } from "./xbd-wxlogin.vue?vue&type=template&id=7fbfe087&"
import script from "./xbd-wxlogin.vue?vue&type=script&lang=js&"
export * from "./xbd-wxlogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports